/**
 * @generated SignedSource<<0e7ba16c0913c047b85da36614a8a95f>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpRespHeroCarousel_user$data = {
  readonly " $fragmentSpreads": FragmentRefs<"HeroCarouselRequestMore_user" | "PdpSharedImageGalleryModal_user" | "ViewInRoom_user">;
  readonly " $fragmentType": "PdpRespHeroCarousel_user";
};
export type PdpRespHeroCarousel_user$key = {
  readonly " $data"?: PdpRespHeroCarousel_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespHeroCarousel_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespHeroCarousel_user",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ViewInRoom_user"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "HeroCarouselRequestMore_user"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedImageGalleryModal_user"
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "b38766020923696761c13beda39836a4";

export default node;
